/**
 * Collection spotlight
 * ---------------------------------------------------------------------------
 * The collection product grid is rendered client-side (the Lambda endpoint in
 * assets/foundrylighting.js replaces the contents of `.product-list` on every
 * load, sort, filter and pagination change). This script takes the markup that
 * sections/collection-spotlight.liquid renders into a <template> and injects it
 * into that grid as a single tile, spanning 2 columns x 2 rows on desktop.
 *
 * Template choice (FLO [2026-09-29, v4.8]): a sort-specific template
 * (<template data-spotlight-sort="best-selling">, from collection_spotlight
 * metaobject entries) wins when it matches the URL's `sort` param; otherwise
 * the collection-level #collection-spotlight-template is used, if any.
 *
 * It only injects on the unfiltered first page of a collection.
 */
(function () {
  'use strict';

  var TEMPLATE_ID = 'collection-spotlight-template';
  var SORTED_SELECTOR = 'template[data-spotlight-sort]';
  var TILE_CLASS = 'collection-spotlight';
  var MIN_CARDS = 8;

  function isSuppressed(allowInStock) {
    var params = new URLSearchParams(window.location.search);

    if (parseInt(params.get('page') || '1', 10) > 1) return true;

    var suppressed = false;

    params.forEach(function (value, key) {
      // "Clear all" leaves an empty q= on the URL, and empty filter values can
      // survive a removed chip — neither is an active refinement.
      if (value === '') return;

      // Sorted-listing tiles feature an in-stock product, so the In Stock filter
      // (ready_to_ship=1, added by the sub-menu links) doesn't hide them.
      if (key === 'ready_to_ship' && allowInStock) return;

      if (key.indexOf('filter.') === 0 || key === 'ready_to_ship' || key === 'q') {
        suppressed = true;
      }
    });

    return suppressed;
  }

  function pickTemplate() {
    var params = new URLSearchParams(window.location.search);
    var sort = params.get('sort') || params.get('sort_by') || '';
    var sorted = document.querySelectorAll(SORTED_SELECTOR);

    if (sort) {
      for (var i = 0; i < sorted.length; i++) {
        if (sorted[i].getAttribute('data-spotlight-sort') === sort) return sorted[i];
      }
    }

    return document.getElementById(TEMPLATE_ID);
  }

  function templateKey(template) {
    if (!template) return '';
    return template.getAttribute('data-spotlight-sort') ? 'sort:' + template.getAttribute('data-spotlight-sort') : 'collection';
  }

  function getList() {
    return document.querySelector('.collection__main .product-list');
  }

  function render() {
    var template = pickTemplate();
    var list = getList();

    if (!list) return;

    var existing = list.querySelector('.' + TILE_CLASS);
    var key = templateKey(template);

    if (!template || !template.content || isSuppressed(!!template.getAttribute('data-spotlight-sort'))) {
      if (existing) existing.remove();
      return;
    }

    if (existing) {
      if (existing.getAttribute('data-spotlight-tile') === key) return;
      existing.remove();
    }

    var cards = list.querySelectorAll(':scope > product-card');
    if (cards.length < MIN_CARDS) return;

    var position = parseInt(template.getAttribute('data-position'), 10);
    if (!position || position < 1) position = 3;

    var tile = template.content.firstElementChild;
    if (!tile) return;

    var clone = tile.cloneNode(true);
    clone.setAttribute('data-spotlight-tile', key);

    var index = Math.min(position - 1, cards.length);
    list.insertBefore(clone, cards[index] || null);
  }

  var timer = null;

  function schedule() {
    // setTimeout rather than requestAnimationFrame: the grid is replaced by an
    // AJAX callback that can land while the tab is backgrounded or prerendered,
    // where rAF is throttled and the tile would never be inserted.
    if (timer) return;

    timer = window.setTimeout(function () {
      timer = null;
      render();
    }, 0);
  }

  function observeList() {
    var list = getList();
    if (!list || list.dataset.spotlightObserved === 'true') return;

    list.dataset.spotlightObserved = 'true';
    new MutationObserver(schedule).observe(list, { childList: true });
    schedule();
  }

  function boot() {
    if (!document.getElementById(TEMPLATE_ID) && !document.querySelector(SORTED_SELECTOR)) return;

    observeList();

    var root = document.querySelector('.collection') || document.body;
    new MutationObserver(observeList).observe(root, { childList: true, subtree: true });

    window.addEventListener('popstate', schedule);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
